import { Module } from '../Module';

Module.instance().directive('tbBackgroundImage',
  () => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attributes: ng.IAttributes) => {
        scope.$watch(attributes['tbBackgroundImage'], (value: any) => {
          element.css('background-image', 'url(' + value + ')');
        });
      }
    };
  }
);
